module.exports = __webpack_public_path__ + "static/resume-manager-243b26e317b8cdf213c5e17b88b877d2.pdf";